<template>
  <div>
    <v-row v-if='value.analytics && value.analytics.staging'>
      <v-col cols='6'>
        <wc-datepicker
          required
          label='Proposed Start Date (staging)'
          v-model='value.analytics.staging.new_start_date'
          :hint='"Previous Season Start Date was: " + $options.filters.shortDate(value.analytics.staging.previous_start_date)'
          persistent-hint
          @change='createNewLog("changed start date to " + $options.filters.shortDate(value.analytics.staging.new_start_date))'
        ></wc-datepicker>
      </v-col>
      <v-col cols='6'>
        <wc-datepicker
          required
          label='Proposed End Date (staging)'
          v-model='value.analytics.staging.new_end_date'
          :hint='"Previous Season End Date was: " + $options.filters.shortDate(value.analytics.staging.previous_end_date)'
          persistent-hint
          @change='createNewLog("changed end date to " + $options.filters.shortDate(value.analytics.staging.new_end_date))'
        ></wc-datepicker>
      </v-col>
    </v-row>
    <v-row>
      <v-card-text class='primary--text font-weight-bold'>Please note - once a project has been activated - change the dates below.  If the project has not been activated (ie. is still in the staging process) - change the dates above and do NOT change the dates below.  Updating the dates below to now/future dates WILL activate the project. (thus it will appear in fieldcrew/schedule/snow dashboard as active)</v-card-text>
      <v-card-text class='error--text font-italic pt-0'>(This process is scheduled for an overhaul once snow staging is complete)</v-card-text>
      <v-col cols='12' md='6'>
        <wc-datepicker
          required
          :max='value.end_date'
          v-model='value.start_date'
          label='Start date'
        ></wc-datepicker>
      </v-col>
      <v-col cols='12' md='6'>
        <wc-datepicker
          required
          :min='value.start_date'
          v-model='value.end_date'
          label='End date'
        ></wc-datepicker>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12' md='6'>
        <v-select
          label='Billing type'
          :items='billingTypes'
          v-model='value.project_detail.billing_type'
        ></v-select>
      </v-col>
      <v-col cols='12' md='6' class='d-flex'>
        <v-select
          label='Renewal Status'
          :items='renewalStatus'
          :item-disabled='p => p.value == "P"'
          v-model='value.project_detail.renewal_status'
          :hint='value.project_detail.renewal_status == "P" ? "Complete all info checks before changing" : ""'
          persistent-hint
          @change='checkStagingStatus'
        ></v-select>
        <v-btn class='mt-3' icon @click='showHelp = !showHelp'>
          <v-icon>mdi-help-circle-outline</v-icon>
        </v-btn>
      </v-col>
      <v-col cols='12'>
        <!-- MJError - some danger with the checkbox - you can uncheck them by clicking to the right of the text (likely undesirable?)-->
        <v-checkbox hide-details v-model='value.project_detail.ice_melt_ok' label='Rock Chip Selected?'></v-checkbox>
        <v-checkbox hide-details v-model='value.project_detail.is_quickpay' label='Is quickpay?'></v-checkbox>
        <v-checkbox hide-details v-model='value.project_detail.do_on_christmas' label='Do on Christmas?'></v-checkbox>
        <v-checkbox hide-details v-model='value.project_detail.lawn_signs_ok' label='Lawn sign?'></v-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12'>
        <v-textarea outlined v-model='value.project_detail.lawn_signs_note' label='Lawn sign note'></v-textarea>
      </v-col>
      <v-col class='text-right my-n6 py-0'>
        <div v-if='confirmation != null' class='caption primary--text'>
          On save - {{ confirmation == 0 ? " project will be set to Cancelled/Declined in staging" : " current staging status will NOT be changed"}}
        </div>
      </v-col>
    </v-row>

    <wc-dialog
      :showDialog='showHelp'
      title='What is renewal status?'
      width='500'
      hideCancel
      saveText='Got it'
      @save='showHelp = false'
    >
      <v-card-text>
        <ul>
          <li>
            <div class='body-2 font-weight-bold'>Pre-check required</div>
            <div class='caption'>Sales Person needs to confirm pricing/suitability of this project.</div>
            <div class='caption font-italic'>Attention required before staging can advance</div><br>
          </li>
          <li>
            <div class='body-2 font-weight-bold'>Offer renewal</div>
            <div class='caption'>Capital is willing to shovel this site again.  Customer response required.</div>
            <div class='caption font-italic'>Normal staging process</div><br>
          </li>
         <!--  <li>
            <div class='body-2 font-weight-bold'>Auto-renew</div>
            <div class='caption'>Customer has indicated they wish to proceed with on-going service.</div>
            <div class='caption font-italic'>Starts staging at "Ready for confirmation"</div><br>
          </li> -->
          <li>
            <div class='body-2 font-weight-bold'>Declined</div>
            <div class='caption'>Project Manager has determined that Capital will not offer service to this client.</div>
            <div class='caption font-italic'>Project will be moved immediately to declined.</div>
            <div class='caption font-italic'>Will enter staging as declined in the future</div>
          </li>
        </ul>
      </v-card-text>
    </wc-dialog>

    <wc-dialog
      :showDialog='showConfirmDecline'
      title='Cancel Staging?'
      width='500'
      saveText='Confirm'
      @cancel='cancelDecline'
      @save="confirmDecline"
    >
      <v-col class='text-center'>
        <span>You have changed renewal status to Declined</span>
        <br><br>
        <!-- <span class='font-weight-bold'>Do you wish to to cancel for this season as well?</span><br> -->
        <span class='font-italic'>The project will be set to Cancelled/Declined within staging</span><br>
        <br>
        <!-- <v-btn-toggle class='mt-4' color='primary' v-model='confirmation'>
            <v-btn small class='caption'>Yes</v-btn>
            <v-btn small class='caption'>No</v-btn>
        </v-btn-toggle> -->
      </v-col>
    </wc-dialog>

  </div>
</template>

<script>
import formRules from '@/mixins/formRules'
import moment from 'moment'

export default {
  name: 'snow-details-form',
  mixins: [formRules],
  data: () => ({
    showHelp: false,
    showConfirmDecline: false,
    confirmation: null,
  }),
  props: {
    value: {
      required: true
    },
    project: {
      required: true
    }
  },
  computed: {
    renewalStatus () {
      return this.$store.state.misc.globalOptions.snowRenewalStatusOptions
    },
     billingTypes () {
      return this.$store.state.misc.globalOptions.snowBillingTypes
    }
  },
  methods: {
    pastDate(date) {
      if (moment().isAfter(date) ) {
        return true
      }
      return false
    },
    checkStagingStatus() {
      if (this.value.project_detail.renewal_status == "D" && this.value.analytics.staging && this.value.analytics.staging.declined == false) {
        this.confirmation = null
        this.showConfirmDecline = true
      }
    },
    confirmDecline() {
      this.confirmation = 0
      this.value.confirmDecline = this.confirmation
      this.showConfirmDecline = false
    },
    cancelDecline() {
      this.value.project_detail.renewal_status = this.project.project_detail.renewal_status
      // reset to the previous value just in case they made a mistake
      this.showConfirmDecline = false
    },
    createNewLog (action) {
      let newLog = {}
      newLog.taken_by = this.$store.state.auth.profile.name_display
      newLog.action_taken = action 
      newLog.date = moment().format('YYYY-MM-DD').toString()
      newLog.time = moment().format('HH:mm:ss').toString()
      this.value.analytics.staging.log.push(newLog) // copy to projectCopy for save
    },
  }
}
</script>
